<template>
  <section id="portfolio-section">
    <PortfolioDialog
      :isPortfolioDialogVisible="isPortfolioDialogVisible"
      :item="selectedPorfolio"
      @hide-dialog="isPortfolioDialogVisible = false"
    />

    <div class="d-flex justify-center">
      <h2 class="title text-center section-title">Portfolio</h2>
      <v-btn
        class="mx-3 my-6"
        aria-label="Github"
        href="https://github.com/mghali1"
        target="_blank"
        fab
        dark
        small
        color="black"
      >
        <v-icon dark>mdi-github</v-icon>
      </v-btn>
    </div>

    <div class="d-flex justify-space-around">
      <v-row
        class="col-9"
        data-aos="flip-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="750"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="true"
      >
        <v-col
          v-for="(portfolio, n) in portfolioList"
          :key="portfolio.name"
          :cols="getCols"
          class="d-flex child-flex"
        >
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 2">
              <v-img
                :src="getImgUrl(portfolio.coverImageSrc)"
                aspect-ratio="1"
                class="portfolio-image"
                @load="() => onImageLoad(n)"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="grey lighten-5" />
                  </v-row>
                </template>
              </v-img>

              <v-card-title
                class="title portfolio-item-title d-flex justify-center"
              >
                <div>{{ portfolio.name }}</div>
              </v-card-title>

              <v-fade-transition>
                <v-overlay v-if="hover" absolute color="pink">
                  <v-btn @click="showPorfolioDialog(n)">See more info</v-btn>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import PortfolioDialog from "@/components/PortfolioDialog.vue";

export default {
  components: { PortfolioDialog },

  metaInfo() {
    return {
      meta: [
        {
          name: "Description",
          content:
            "Finpaw pet-adoption app, Pitch Kings competition platform, Mappable accessible map, Al-Halabi Oman website",
        },
      ],
    };
  },

  data() {
    return {
      imagesAreLoading: true,
      isPortfolioDialogVisible: false,
      selectedPorfolio: {},

      // ORDER: Finpaw → Pitch Kings → Mappable → Al-Halabi
      portfolioList: [
        {
          name: "Finpaw",
          coverImageSrc: "finpaw_logo.png",
          description: `
            <strong>Finpaw</strong> — an end-to-end pet-adoption platform.<br/>
            I handled everything: <strong>Flutter iOS/Android app + Firebase backend + GoLang APIs</strong>.<br/>
            Features include pet listings, geolocation search, events & sitter services.<br/>
            Download it from <a href="https://finpaw.org/download" target="_blank" rel="noopener">finpaw.org/download</a>.
          `,
          startingDate: "Jan 2022",
          mvpTimespan: "≈ 4 months",
          stackUsed: "Flutter (iOS + Android) · GoLang · Firebase · PostgreSQL",
          media: [{ type: "image", src: "finpaw_logo.png" }],
        },

        {
          name: "Pitch Kings",
          coverImageSrc: "PitchKingsLogo.jpeg",
          description: `
            An online booking system for sport pitches. It contains a player-facing and a manager-facing flow.<br/>
            Built the full web platform myself (backend / frontend / DB).
          `,
          startingDate: "Jun 2019",
          mvpTimespan: "≈ 3 months",
          stackUsed: "PHP · MySQL · Bootstrap · jQuery",
          media: [
            {
              type: "html",
              src:
                '<iframe width="100%" height="315" src="https://www.youtube.com/embed/P8KkddyFCvE" frameborder="0" allowfullscreen></iframe>',
            },
            {
              type: "html",
              src:
                '<iframe width="100%" height="315" src="https://www.youtube.com/embed/JZJp8j0vH8U" frameborder="0" allowfullscreen></iframe>',
            },
          ],
        },

        {
          name: "Mappable",
          coverImageSrc: "MappableLogo.jpg",
          description: `
            <strong>Mappable</strong> — AUB Final-Year Project: an accessible web-mapping solution.<br/>
            Won the <strong>Murex Best Final Year Project Award</strong>.
          `,
          startingDate: "Sep 2019",
          mvpTimespan: "≈ 3 months",
          stackUsed: "JavaScript · HTML5 · CSS3",
          media: [
            {
              type: "html",
              src:
                '<iframe width="100%" height="315" src="https://www.youtube.com/embed/jkWT7Y30RFE" frameborder="0" allowfullscreen></iframe>',
            },
            { type: "image", src: "mappableAward1.jpeg" },
            { type: "image", src: "mappableAward2.jpeg" },
          ],
        },

        {
          name: "Al-Halabi Oman",
          coverImageSrc: "AlHalabiOman.png",
          description: `
            Corporate website for the Al-Halabi Oman restaurants chain.<br/>
            WordPress-based with custom styling and menu system.
          `,
          startingDate: "Jun 2020",
          mvpTimespan: "≈ 1 month",
          stackUsed: "WordPress · Custom CSS/JS/PHP",
          media: [
            {
              type: "html",
              src:
                '<iframe width="100%" height="315" src="https://www.youtube.com/embed/81whi7Yx2Zc" frameborder="0" allowfullscreen></iframe>',
            },
          ],
        },
      ],
    };
  },

  computed: {
    getCols() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        default:
          return 3;
      }
    },
    isLoading() {
      return this.imagesAreLoading;
    },
  },

  methods: {
    showPorfolioDialog(index) {
      this.selectedPorfolio = this.portfolioList[index];
      this.isPortfolioDialogVisible = true;
    },

    // images expected under  public/assets/
    getImgUrl(imageName) {
      return `/assets/${imageName}`;
    },

    onImageLoad(index) {
      this.$set(this.portfolioList[index], "isLoaded", true);
      if (this.portfolioList.every((item) => item.isLoaded)) {
        this.imagesAreLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#portfolio-section {
  padding-top: 15px;
  padding-bottom: 35px;
}
.portfolio-item-title {
  text-align: center;
}
.section-title {
  margin-top: 30px;
}
</style>
